var React = require('react');

function PolygonUpTime (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m3.56699.75c.19245-.333334.67357-.333333.86602 0l2.59808 4.5c.19245.33333-.04811.75-.43301.75h-5.19616c-.3849 0-.625459-.41667-.433009-.75z","fill":"#1f2e5c","opacity":".8"}));
}

PolygonUpTime.defaultProps = {"className":"mr-1 polygon-up-time","fill":"none","height":"6","viewBox":"0 0 8 6","width":"8"};

module.exports = PolygonUpTime;

PolygonUpTime.default = PolygonUpTime;
